import { ShepherdService } from 'angular-shepherd';
import Step from 'shepherd.js/src/types/step';
import {
  SHEPHERD_NEXT_BUTTON_CLASSES,
  SHEPHERD_PREVIOUS_BUTTON_CLASSES,
  SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT,
} from '../constants';
import { SHEPHERD_CARD_TYPES } from '../model';
import { offset } from '@floating-ui/dom';

export namespace InstallationsListShepherdScenario {
  export function getScenarioSteps(): Array<Step.StepOptions> {
    const attachShepherdCardElement = this.attachShepherdCardElement.bind(
      this,
      SHEPHERD_CARD_TYPES.LIST
    );
    const attachShepherdStepCounterElement = this.attachShepherdStepCounterElement.bind(this);
    const shepherdService: ShepherdService = this.shepherdService;

    return [
      {
        id: 'installationsListIntro',
        arrow: false,
        canClickTarget: false,
        classes: 'shepherd-grid-modal shepherd-bottom-left',
        buttons: [
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.INTRODUCTION_TITLE'),
        text: [this.translateService.instant('+SHEPHERD.KANBAN.LIST.INTRODUCTION_DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdCardElement();
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'installationsListSwitchingViews',
        arrow: true,
        canClickTarget: false,
        attachTo: {
          element: '#shepherd-installationsView-2',
          on: 'bottom-start',
        },
        classes: 'shepherd-bubble-modal',

        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.SWITCHING_VIEWS_TITLE'),
        text: [this.translateService.instant('+SHEPHERD.KANBAN.LIST.SWITCHING_VIEWS_DESCRIPTION')],
        showOn: (): boolean => {
          let elementPresent = document.querySelector('#shepherd-installationsView-2');

          return !!elementPresent;
        },
        when: {
          show(): void {
            window.scrollTo(0, 0);
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'installationsListFilterAndSearch',
        arrow: true,
        canClickTarget: false,
        attachTo: {
          element: '[data-at-kanban-filters]',
          on: 'bottom',
        },
        classes: 'shepherd-bubble-modal',
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.FILTER_AND_SEARCH_TITLE'),
        text: [
          this.translateService.instant('+SHEPHERD.KANBAN.LIST.FILTER_AND_SEARCH_DESCRIPTION'),
        ],
        showOn: (): boolean => {
          let elementPresent = document.querySelector('#shepherd-installationsView-3');

          return !!elementPresent;
        },
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'snapshotSynchronize',
        canClickTarget: false,
        attachTo: {
          element: '[data-at-snapshot-synchronize]',
          on: 'bottom',
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.SYNCHRONIZE_BUTTON.TITLE'),
        text: [this.translateService.instant('+SHEPHERD.SYNCHRONIZE_BUTTON.DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'installationsListPredefinedFilters',
        arrow: true,
        canClickTarget: false,
        attachTo: {
          element: '#shepherd-installationsView-4',
          on: 'bottom',
        },
        classes: 'shepherd-bubble-modal',
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.PREDEFINED_FILTERS_TITLE'),
        text: [
          this.translateService.instant('+SHEPHERD.KANBAN.LIST.PREDEFINED_FILTERS_DESCRIPTION'),
        ],
        showOn: (): boolean => {
          let elementPresent = document.querySelector('#shepherd-installationsView-4');

          return !!elementPresent;
        },
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'installationsListListItem',
        arrow: true,
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElement('div.wrapper');
        },
        attachTo: {
          element: 'app-installation-list-table-entry',
          on: 'bottom',
        },
        classes: 'shepherd-bubble-modal',
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.LIST_ITEM_TITLE'),
        text: [this.translateService.instant('+SHEPHERD.KANBAN.LIST.LIST_ITEM_DESCRIPTION')],
        showOn: (): boolean => {
          let elementPresent = document.querySelector('app-installation-list-table-entry');

          return !!elementPresent;
        },
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'installationsListUpgradeBadge',
        arrow: true,
        scrollTo: true,
        canClickTarget: false,
        attachTo: {
          element: 'app-installation-list-table-entry app-pill.upgrade-pill',
          on: 'bottom',
        },
        scrollToHandler: (): void => {
          this.scrollToElement('app-installation-list-table-entry app-pill.upgrade-pill');
        },
        classes: 'shepherd-bubble-modal',
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.UPGRADE_TO_PRO_TITLE'),
        text: [this.translateService.instant('+SHEPHERD.KANBAN.LIST.UPGRADE_TO_PRO_DESCRIPTION')],
        showOn: (): boolean => {
          let elementPresent = document.querySelector(
            'app-installation-list-table-entry app-pill.upgrade-pill'
          );

          return !!elementPresent;
        },
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'installationsListStatusBadges',
        arrow: true,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElement('div.wrapper');
        },
        canClickTarget: false,
        attachTo: {
          element: 'app-installation-list-table-entry app-installation-tile-badges',
          on: 'bottom-end',
        },
        classes: 'shepherd-bubble-modal',
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              document.querySelector('app-installation-list-table-entry a')['click']();
              shepherdService.next();
            },
          },
        ],
        showOn: (): boolean => {
          let elementPresent = document.querySelector(
            'app-installation-list-table-entry app-installation-tile-badges'
          );

          return !!elementPresent;
        },
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.INSTALLATION_STATUS_TITLE'),
        text: [
          this.translateService.instant('+SHEPHERD.KANBAN.LIST.INSTALLATION_STATUS_DESCRIPTION'),
        ],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'installationsListSidepanel',
        arrow: window.innerWidth >= SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT,
        canClickTarget: false,
        attachTo: {
          element:
            window.innerWidth < SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT
              ? 'app-kanban-quick-view-header'
              : 'app-kanban-quick-view-wrapper',
          on: 'left',
        },
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              document.querySelector('app-kanban-quick-view-wrapper .header mat-icon')['click']();
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.CLOSE'),
            action(): void {
              document.querySelector('app-kanban-quick-view-wrapper .header mat-icon')['click']();
              shepherdService.complete();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN.LIST.QUICK_VIEW_TITLE'),
        text: [this.translateService.instant('+SHEPHERD.KANBAN.LIST.QUICK_VIEW_DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
          cancel(): void {
            document.querySelector('app-kanban-quick-view-wrapper .header mat-icon')['click']();
          },
        },
      },
    ];
  }
}
